import Student from '../../model/Student';
import { CircularProgress, Collapse, Divider, Grid, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { UserDataText } from './UserPanel';
import { GridProps } from '@mui/material/Grid/Grid';
import Teacher from '../../model/Teacher';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const Row = (props: GridProps) => {
	return (
		<Grid
			item
			container
			justifyContent={'space-between'}
			{...props}
		>
			{props.children}
		</Grid>
	);
};

type Props = {
	student: Student | null;
};
const UserData = ({ student }: Props) => {
	const { palette } = useTheme();
	const [expand, setExpand] = useState(true);

	return (
		<>
			<Grid
				item
				container
				justifyContent={'space-between'}
				mt={5}
				onClick={() => setExpand(!expand)}
				sx={{ cursor: 'pointer' }}
			>
				<Typography
					variant={'h4'}
					fontWeight={'500'}
					color={palette.primary.main}
				>
					Twoje dane
				</Typography>
				{expand ? (
					<KeyboardArrowUpIcon sx={{ color: palette.primary.main }} />
				) : (
					<KeyboardArrowDownIcon sx={{ color: palette.primary.main }} />
				)}
			</Grid>
			<Divider
				variant={'fullWidth'}
				sx={{
					backgroundColor: palette.secondary.light,
					borderBottomWidth: '3px',
				}}
			/>
			<Collapse in={expand}>
				<Grid
					item
					container
					justifyContent={'start'}
					width={'100%'}
					gap={'24px'}
				>
					{!student ? (
						<Row>
							<Grid
								item
								container
								alignItems='center'
								gap='12px'
							>
								<CircularProgress size={18} />
								<UserDataText text={'Trwa odczyt danych'} />
							</Grid>
						</Row>
					) : (
						<>
							<Row>
								<UserDataText
									title={'Identyfikator: '}
									text={`${student?.district.id.toString().padStart(4, '0')} - ${student?.id.toString().padStart(6, '0')}`}
								/>
							</Row>
							<Row>
								<UserDataText
									title={'Imię i nazwisko: '}
									text={`${student?.personalTitle} ${student?.firstName} ${student?.lastName}`}
								/>
							</Row>
							<Row>
								<UserDataText
									title={'Drugie imię: '}
									text={`${student?.secondName}`}
								/>
							</Row>
							<Row>
								<UserDataText
									title={'Adres: '}
									text={`${student?.street} ${student?.building} ${student?.apartment}, ${student?.zipCode} ${student?.country ? `${student.country}: ` : ''}${student?.city}`}
								/>
							</Row>
							<Row>
								<UserDataText
									title={'Szkoła: '}
									text={`${student?.school.name} ${student?.school.city}`}
								/>
								<UserDataText
									title={'Klasa: '}
									text={`${
										student?.schoolClassText && student.schoolClassText.trim() !== ''
											? student.schoolClassText
											: String(student?.schoolClass ?? '')
									}`}
								/>
							</Row>
							<Row>
								<UserDataText
									title={'Specjalizacja: '}
									text={`${student?.specialization.name}`}
								/>
								<UserDataText
									title={'Opiekunowie: '}
									text={`${student?.teachers.map((t: Teacher) => `${t.firstName} ${t.lastName}`).join(', ')}`}
								/>
							</Row>
							<Row>
								<UserDataText
									title={'Orzeczenie / opinia o dysgrafii: '}
									text={student?.specialCertificate ? 'Tak' : 'Nie'}
									fullwidth
								/>
							</Row>
						</>
					)}
				</Grid>
			</Collapse>
		</>
	);
};

export default UserData;
